import React from 'react'
import { Button } from 'react-weui'
import {connect} from 'react-redux'
import axios from 'axios'

import { Page } from '../../components'
import {isLZWKAPP, judgeAPPVersion} from '../../utils';
import tipImg from '../../images/liveroom/tips-link.png'
import managerImg from '../../images/liveroom/no-invite-manager.png'


class LiveroomLecturerManagerInvitePage extends React.Component {
    constructor() {
        super();
        this.handleAcceptInvite = this.handleAcceptInvite.bind(this);
    }

    handleAcceptInvite() {
        const {shareTitle, shareDesc, shareIcon, shareLink} = this.state;

        if (window.systemType === 'android') {
            WKApp.shareUrl(shareTitle, shareDesc, shareLink, shareIcon);
        }

        if (window.systemType === 'ios') {
            window.webkit.messageHandlers.WKApp.postMessage({
                "function": "shareUrl",
                "json": {
                    "share_description": shareDesc,
                    "share_icon": shareIcon,
                    "share_title": shareTitle,
                    "share_url": shareLink,
                }
            })
        }
    }

    componentDidMount() {
        const {liveroom_id} = this.props.params;
        axios.get(`/api/liveroom/${liveroom_id}/manager/invite_info`).then(res => {
            if (res.data.code === 0) {
                let share_info = res.data.data.share_info;
                // init share
                let shareUrl = location.origin + `/liveroom/${liveroom_id}/edit/accept/invite?` + share_info.share_url.split('?')[1];
                this.props.dispatch({
                    type: 'UPDATE_SHARE_DATA',
                    payload: {
                        title: share_info.share_title,
                        desc: share_info.share_description,
                        imgUrl: share_info.share_icon,
                        link: shareUrl,
                    }
                });
                this.setState({
                    shareTitle: share_info.share_title,
                    shareDesc: share_info.share_description,
                    shareIcon: share_info.share_icon,
                    shareLink: shareUrl
                })
            }
        })
    }

    render() {
        const isApp = isLZWKAPP() && ((window.systemType === 'ios' && judgeAPPVersion(360)) || (window.systemType === 'android' && judgeAPPVersion(260)));
        return (
            <Page>
                <div className="wk-inner-page liveroom-setting-manage-page invite">
                    {!isApp &&
                    <div>
                        <div className="tip">
                            <img src={tipImg} />
                        </div>
                        <div className="tips-share-text">
                            <p>点击右上角分享</p>
                            <p>邀请好友成为管理员吧！</p>
                        </div>
                    </div>
                    }
                    <div className="content">
                        <div className="pic">
                            <img src={managerImg} />
                        </div>
                        <div className="text">
                            <p>分享此页面，好友点击链接确认后</p>
                            <p>即可成为店铺管理员</p>
                        </div>
                        {isApp &&
                        <Button onClick={this.handleAcceptInvite}>邀请好友成为管理员</Button>
                        }
                    </div>
                </div>
            </Page>
        )
    }
}

export default connect(() => ({}))(LiveroomLecturerManagerInvitePage)


// WEBPACK FOOTER //
// ./src/pages/liveroomLecturer/LiveroomLecturerManagerInvitePage.js